import { render } from "./person-check.vue?vue&type=template&id=280fdc6f"
import script from "./person-check.vue?vue&type=script&lang=js"
export * from "./person-check.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__